import React, { useEffect, useRef, useState } from "react";
import { Col, Table, Form, Row, Spinner, Stack } from "react-bootstrap";
import { PunchItemRemarksCell, usePunchRequestRemarks } from "../../components/ItemRemarks";
import { BsQuestionLg } from "react-icons/bs";
import Select from "react-select";
import { toast } from "react-toastify";
import useApproveRight, { APPROVE_DENIED_MESSAGE } from "../../utils/useApproveRight";
import { ErrorMessage, Field, FieldArray, Formik } from "formik";
import {
  getStockPunchDetailsById,
  postApproveStockPunch,
} from "../../services/contractorApi";
import { Helmet } from "react-helmet";
import CardComponent from "../../components/CardComponent";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import ConfirmAlert from "../../components/ConfirmAlert";
import { getAllComplaintIdListMangerWise, getAllComplaintIdList } from "../../services/contractorApi";
import moment from "moment";

import { useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";
import ViewExpensePunch from "../ExpenseManagement/ViewExpensePunch";
import { PaymentImages } from "../ExpenseManagement/PaymentImages";
import {
  getAllOfficeUser,
  getSingleUserById,
} from "../../services/contractorApi";
import { getAllManager } from "../../services/contractorApi";
import { getTeamsDetailbyuserid } from "../../services/contractorApi";
import { getSupervisorListWithTotalFreeUserByManagerId } from "../../services/contractorApi";
import { useTranslation } from "react-i18next";
import { getAllManagersUser } from "../../services/contractorApi";
import { getAllEndUserBySupervisorId } from "../../services/contractorApi";

import { getAllRegionalOffice } from "../../services/contractorApi";
import { getSalesOnRoId } from "../../services/authapi";
import DatePickercomp from "../../components/DatePicker";
import { getAllAreaManager } from "../../services/contractorApi";
import MyInput from "../../components/MyInput";
import { twoDecimal, onlyDecimalKey, handleDecimalPaste, formatAmountINR } from "../../utils/helper";

const ApproveStockPunch = () => {
  const { t } = useTranslation();
  const { user } = useSelector(selectUser);
  const { id } = useParams();
  // each item's earlier remarks (Request / Approve / Transfer of the requests
  // these pending punches drew from), in the row's Remarks cell
  const punchRemarks = usePunchRequestRemarks("stock", { punch: { punchId: id, pending: true } });
  const navigate = useNavigate();
  const location = useLocation();
  const [complaintData, setComplaintData] = useState([]);

  const userId = location?.state?.userId;
  const Complain_id = location?.state?.Complain_id;
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type") || null;
  // Approve right of this screen (sidebar tree); the API enforces it too.
  const { canApprove } = useApproveRight();
  // DAY-WISE: scope the approve detail to a single day. Prefer the URL
  // ?punch_date= (survives a page refresh / direct open) and fall back to the
  // router state. Absent => no day scoping (backward compatible). Without this,
  // a refresh loses location.state and the detail aggregates ALL days -> shows
  // the full multi-day total instead of the clicked day's punch.
  const punch_date =
    searchParams.get("punch_date") || location?.state?.punch_date || "";
  const [edit, setEdit] = useState({});
  // In-flight guard: the approve request is slow (whole punch batch + ledger),
  // so the operator clicked Confirm repeatedly and each click fired a separate
  // approval — six "approved successfully" toasts. Formik's isSubmitting flips
  // synchronously but the disabled button only re-renders next tick, so two
  // fast clicks can both slip through; this ref blocks every click after the
  // first until the round trip finishes. (The backend claim-first guard already
  // stops any double DEBIT — this stops the duplicate REQUESTS and the noise.)
  const submittingRef = useRef(false);
  const [showAlert, setShowAlert] = useState(false);
  const [allOfficeUser, setAllofficeUser] = useState([]);
  const [managerId, setManagerId] = useState({
    type: "",
    id: "",
  });
  const [complaintDetails, setComplaintDetails] = useState({});
  const [freeSupervisorData, setFreeSupervisorData] = useState([]);
  const [freeUserData, setFreeUserData] = useState([]);
  const [teamsDetails, setTeamsDetails] = useState({});
  const [allManager, setAllManager] = useState([]);
  const [allManagers, setAllManagers] = useState([]);
  const [allRegionalOffice, setAllRegionalOffice] = useState([]);
  const [selectedSAId, setSelectedSAId] = useState(null);
  const [allSa, setAllSa] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [officeSelectedByUser, setOfficeSelectedByUser] = useState(false);
  const [managerSelectedByUser, setManagerSelectedByUser] = useState(false);

  // [setAllofficeUser]

  // const fetchRegionalOfficeList = async () => {
  //   const res = await getAllRegionalOffice({});
  //   if (res.status) {
  //     setAllRegionalOffice(res.data);
  //   } else {
  //     setAllRegionalOffice([]);
  //   }
  // };

  const fetchRegionalOfficeList = async () => {
    const res = await getAllRegionalOffice({});
    if (res.status) {
      const options = res.data.map((itm) => ({
        label: itm.regional_office_name,
        value: itm.ro_id,
      }));
      setAllRegionalOffice(options);
    } else {
      setAllRegionalOffice([]);
    }
  };

  // const fetchSingleData = async () => {
  //   const res = await getStockPunchDetailsById(userId, Complain_id);

  //   if (res.status) {
  //     setEdit(res.data);
  //   } else {
  //     setEdit([]);
  //   }
  // };

  //   submit form

  const fetchSingleData = async () => {
    const res = await getStockPunchDetailsById(userId, Complain_id, punch_date);

    if (res.status) {
      setEdit(res.data);

      const row = res.data?.[0]; // ✅ pehle define karo
      // ✅ manager list = sirf isi stock record ka manager
      // ✅ team structure load from stock punch user
      console.log("ROW DATA:", row);
      if (row?.user_id) {
        await getTeamsDetailsbyuserid(row.user_id);
      }
      if (row?.manager_id) {
        fetchAreaManager(row.manager_id);
        setManagerId({ type: "manager", id: row.manager_id });
      } else {
        setManagerId({ type: "office", id: row.user_id || "" });
      }

      // 🔥 EXPENSE WALI TARAH CARD PREFILL
      setComplaintDetails({
        companyDetails: row?.complaintsDetails?.companyDetails,

        complaint_punched_amount: row?.stock_punch_transfer || 0,

        outlet_category:
          row?.complaintsDetails?.companyDetails?.outletDetail
            ?.outlet_category || "-",
      });

      // 🔥 USER CARD PREFILL — real user-level stock totals from the API
      // (user_stock_summary), not the same stock_punch_transfer field for
      // every cell with a hardcoded ₹0.00 remaining.
      setUserDetails({
        request_by_name: row?.user_name,
        transfer_amount:
          res?.user_stock_summary?.total_transfer_amount ??
          row?.stock_punch_transfer,
        expense_transfer_amount:
          res?.user_stock_summary?.total_punched_amount ??
          row?.stock_punch_transfer,
        remaining_amount: res?.user_stock_summary?.total_remaining_amount ?? 0,
      });
    } else {
      setEdit([]);
    }
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    if (type !== "view" && !canApprove) {
      toast.error(APPROVE_DENIED_MESSAGE);
      return;
    }
    // Block re-entry from a rapid second click before the button re-renders.
    if (submittingRef.current) return;
    submittingRef.current = true;

    const items = values?.items
      ?.map((d) => (d.approved_qty ? d : null))
      ?.filter((item) => item !== null);

    // const items = values?.items?.filter((d) => d.approved_qty);

    const punch_date = moment(values?.punch_date).format("YYYY-MM-DD");

    const modifiedData = items?.map((data) => {
      return {
        item_id: data.item_id,
        id: data.id,
        item_qty: data.approved_qty,
        transaction_id: data.transaction_id,
        remaining_qty: data.remaining_qty,
      };

    });

    const totalAmount =
      Math.round(
        (values?.items?.reduce(
          (total, item) => total + Number(item.total_price || 0),
          0,
        ) || 0) * 1000,
      ) / 1000;

    const sData = {
      items: modifiedData,
      total_amount: totalAmount,
      transaction_images: values.payment_images,
      complaint_id: items[0]?.complaint_id,
      user_id: items[0]?.user_id,
      punch_date: punch_date
     
      
    };

    try {
      const res = await postApproveStockPunch(sData);

      if (res.status) {
        toast.success(res.message);
        setShowAlert(false);
        navigate(-1);
      } else {
        toast.error(res.message);
      }
    } finally {
      resetForm();
      setSubmitting(false);
      submittingRef.current = false;
    }
  };

  const handleManagerChange = async (value) => {
    if (!value) return setFreeSupervisorData([]);
    fetchFreeSupervisorData(value);
  };

  const getTeamsDetailsbyuserid = async (userid) => {
    const res = await getTeamsDetailbyuserid(userid);
    if (res.status) {
      // setComplaintDetails(res.data[0]);
      setTeamsDetails(res.data[0]);
      // console.log(`teamsDetails`, teamsDetails);
    } else {
      // setComplaintDetails({});
      setTeamsDetails({});
    }
  };
  // const fetchFreeSupervisorData = async (id) => {
  //   const res = await getSupervisorListWithTotalFreeUserByManagerId(id);
  //   if (res.status) {
  //     const supervisor = res.data.filter(
  //       (manager) => manager.id === teamsDetails?.supervisor,
  //     );
  //     setFreeSupervisorData(supervisor);
  //   } else {
  //     setFreeSupervisorData([]);
  //     toast.error(res.message);
  //   }
  // };

  const fetchFreeSupervisorData = async (managerId) => {
    const res = await getSupervisorListWithTotalFreeUserByManagerId(managerId);

    if (res.status) {
      let data = res.data;

      // ✅ sirf us stock punch wala supervisor rakho
      if (teamsDetails?.supervisor) {
        data = res.data.filter((s) => s.id === teamsDetails.supervisor);
      }

      setFreeSupervisorData(data);
    } else {
      setFreeSupervisorData([]);
      toast.error(res.message);
    }
  };

  // const fetchFreeUsersData = async (id) => {
  //   const res = await getAllEndUserBySupervisorId(id);
  //   if (res.status) {
  //     const user = res.data.filter(
  //       (manager) => manager.id === teamsDetails?.team_member,
  //     );
  //     setFreeUserData(user);
  //   } else {
  //     setFreeUserData([]);
  //     toast.error(res.message);
  //   }
  // };

  const fetchFreeUsersData = async (supervisorId) => {
    const res = await getAllEndUserBySupervisorId(supervisorId);

    if (res.status) {
      let data = res.data;

      // ✅ sirf us stock punch wala end user
      if (teamsDetails?.team_member) {
        data = res.data.filter((u) => u.id === teamsDetails.team_member);
      }

      setFreeUserData(data);
    } else {
      setFreeUserData([]);
      toast.error(res.message);
    }
  };

  const handleSupervisorChange = async (value, setvalue) => {
    if (setvalue) {
      setvalue(`request_data[${id}].supervisor_id`, value);
      setvalue(`request_data[${id}].end_users_id`, "");
    }
    if (!value) return setFreeUserData([]);
    fetchFreeUsersData(value);
  };

  // const allItems =
  // edit.length > 0 &&
  //   edit
  //     .map((data) => {
  //       if (data?.remaining_approved_qty > 0)
  //         return {
  //           id: data.id,
  //           item_name: data?.item_name,
  //           item_images: data?.item_images,
  //           item_id: data?.item_id,
  //           item_price: data?.item_price,
  //           remaining_approved_qty: data?.remaining_approved_qty,
  //           supplier_name: data?.supplier_name,
  //           total_Amount: data?.total_Amount,
  //           punch_at: data.punch_at,
  //           complaint_id: data.complaint_id,
  //           user_id: data.user_id,
  //           total_price: 0,
  //         }})
  const allItems =
    edit.length > 0 &&
    edit
      .filter((d) => d.remaining_approved_qty > 0)
      .map((d) => ({
        id: d.id,
        item_name: d.item_name,
        item_images: d.item_images,
        item_id: d.item_id,
        item_price: d.item_price,

        // stock side
        punch_qty: d.item_qty,
        // Use the backend's per-batch 2-dp total_Amount (which equals the amount
        // approveStockPunch actually debits). Do NOT re-multiply qty × avg-rate
        // here — that 4-dp/averaged value diverges from the real debit.
        punch_amount: d.total_Amount,

        approved_qty: "",
        approve_amount: 0,

        // remaining_qty: d.remaining_approved_qty,
        // remaining_amount: d.remaining_approved_qty * d.item_price,
        remaining_qty:  d.stock_remining_qty,
        remaining_amount: d.stock_remaining_amount || 0,
        original_remaining_qty: d.stock_punch_qty || d.item_qty || 0,
        original_remaining_amount: d.original_remaining_amount || 0,
        punch_at: d.punch_at,
        complaint_id: d.complaint_id,
        user_id: d.user_id,
        rate_breakdown: d.rate_breakdown || [],

        total_price: 0,
      }))
      .filter((item) => item !== undefined);
  console.log("Mapped allItems =", allItems);

  // const fetchSaData = async (ro_id) => {
  //   const res = await getSalesOnRoId(ro_id);
  //   if (res.status) {
  //     setAllSa(res.data);
  //     // toast.success(res.message);
  //   } else {
  //     setAllSa([]);
  //     toast.error(res.message);
  //   }
  // };

  //   const fetchSaData = async (ro_id) => {
  //   const res = await getSalesOnRoId(ro_id);
  //   if (res.status) {
  //     const options = res.data.map((itm) => ({
  //       label: itm.sales_area_name,
  //       value: itm.id,
  //     }));
  //     setAllSa(options);
  //   } else {
  //     setAllSa([]);
  //     toast.error(res.message);
  //   }
  // };

  // useEffect(() => {
  //   if (id !== "new") {
  //     fetchSingleData();
  //   }
  // }, []);

  // const fetchSaData = async (ro_id) => {
  //   const res = await getSalesOnRoId(ro_id);
  //   if (res.status) {
  //     setAllSa(res.data);
  //     // toast.success(res.message);
  //   } else {
  //     setAllSa([]);
  //     toast.error(res.message);
  //   }
  // };

  const fetchSaData = async (ro_id) => {
    const res = await getSalesOnRoId(ro_id);

    if (res.status) {
      const options = res.data.map((itm) => ({
        label: itm.sales_area_name,
        value: itm.id,
      }));

      setAllSa(options);
      return options; // ⭐ VERY IMPORTANT
    } else {
      setAllSa([]);
      return [];
    }
  };

  // useEffect(() => {
  //   fetchRegionalOfficeList();
  //   fetchComplaintData();
  // }, [managerId]);

  useEffect(() => {
    fetchRegionalOfficeList();
  }, []);

  // Complaint options depend on WHICH manager/office this punch belongs to,
  // and that is only known after fetchSingleData (or the team auto-fill) sets
  // managerId. Re-fetch whenever it changes so the prefilled complaint_id can
  // actually be found among the options and render as selected.
  useEffect(() => {
    fetchComplaintData();
  }, [managerId]);

  // useEffect(() => {
  //   if (id !== "new") {
  //     fetchSingleData();
  //   }

  //   getTeamsDetailsbyuserid(id);
  //   fetchOfficeUser();
  //   // fetchAreaManager();
  // }, [managerId]);

  useEffect(() => {
    const init = async () => {
      await fetchRegionalOfficeList(); // RO options first
      await fetchSingleData(); // then edit data
      // await fetchOfficeUser();           // office select
      getTeamsDetailsbyuserid(id);
    };

    if (id !== "new") init();
  }, []);

  // ✅ Sales Area auto load after edit data comes
  // useEffect(() => {
  //   const roId =
  //     edit?.[0]?.complaintsDetails?.companyDetails
  //       ?.selectedRegionalOffices?.[0]?.id;

  //   if (roId) fetchSaData(roId);
  // }, [edit]);

  useEffect(() => {
    const loadSA = async () => {
      const roId =
        edit?.[0]?.complaintsDetails?.companyDetails
          ?.selectedRegionalOffices?.[0]?.id;

      if (!roId) return;

      const saOptions = await fetchSaData(roId);

      const saId =
        edit?.[0]?.complaintsDetails?.companyDetails?.selectedSaleAreas?.[0]
          ?.id;

      const selectedSA = saOptions.find((sa) => sa.value === saId);

      // ⭐ force Formik sync (VERY IMPORTANT)
      if (selectedSA) {
        setTimeout(() => {
          document
            .querySelector('[name="sales_area_id"]')
            ?.dispatchEvent(new Event("change", { bubbles: true }));
        }, 0);
      }
    };

    if (edit?.length) loadSA();
  }, [edit]);

  // ✅ AUTO: manager → supervisor → enduser → complaint
  useEffect(() => {
    console.log("teamsDetails =", teamsDetails);
    if (!teamsDetails || Object.keys(teamsDetails).length === 0) return;

    if (teamsDetails?.manager) {
      // Manager/supervisor dropdowns still auto-fill, but an OFFICE selection
      // (row prefill or the operator's own pick) must keep driving the
      // complaint list — this effect used to silently overwrite it with the
      // team manager, so the office/all-complaints list never appeared.
      setManagerId((prev) =>
        prev?.type === "office" && prev?.id
          ? prev
          : { type: "manager", id: teamsDetails.manager },
      );

      fetchAreaManager(teamsDetails.manager);
      fetchFreeSupervisorData(teamsDetails.manager);
    }

    if (teamsDetails?.supervisor) {
      fetchFreeUsersData(teamsDetails.supervisor);
    }
  }, [teamsDetails]);

  // ✅ supervisor auto-load from stock punch team data
  // useEffect(() => {
  //   if (teamsDetails?.manager) {
  //     fetchFreeSupervisorData(teamsDetails.manager);
  //   }
  // }, [teamsDetails]);

  // ✅ manager auto-load from team data
  // useEffect(() => {
  //   if (teamsDetails?.manager) {
  //     fetchAreaManager();
  //   }
  // }, [teamsDetails]);
  // useEffect(() => {
  //   fetchAreaManager();
  // }, [teamsDetails]);

  // const fetchAreaManager = async () => {
  //   const res = await getAllAreaManager();
  //   if (res.status) {
  //     console.log(`teamsDetails`, teamsDetails);
  //     const managers = res.data.filter(
  //       (manager) => manager.id == teamsDetails?.manager,
  //     );
  //     console.log(`managers`, managers);
  //     setAllManager(managers);
  //   } else {
  //     setAllManager([]);
  //   }
  // };

  const fetchAreaManager = async (managerIdFromStock) => {
    const res = await getAllAreaManager();

    if (res.status) {
      const filtered = res.data.filter((m) => m.id === managerIdFromStock);

      setAllManager(filtered); // ✅ only that manager in dropdown
    } else {
      setAllManager([]);
    }
  };

  // const fetchComplaintData = async () => {
  //   const res = await getAllComplaintIdListMangerWise(managerId.id);
  //   if (res.status) {
  //     setComplaintData(res.data);
  //   } else {
  //     setComplaintData([]);
  //   }
  // };

  //  const fetchComplaintData = async () => {
  //   if (!managerId || !managerId.id) {
  //     setComplaintData([]);
  //     return;
  //   }

  //   const res = await getAllComplaintIdListMangerWise(managerId.id);
  //   if (res.status) {
  //     setComplaintData(res.data);
  //   } else {
  //     setComplaintData([]);
  //   }
  // };

  // const fetchOfficeUser = async () => {
  //   const res = await getAllOfficeUser();

  //   if (res.status) {
  //     let data = res.data.filter((officeUser) => officeUser?.id == id);
  //     setAllofficeUser(data);
  //   } else {
  //     setAllofficeUser([]);
  //   }
  // };

  //   const fetchOfficeUser = async () => {
  //   const res = await getAllOfficeUser();

  //   if (res.status) {
  //     setAllofficeUser(res.data);   // ✅ no filter
  //   } else {
  //     setAllofficeUser([]);
  //   }
  // };

  useEffect(() => {
    if (managerId?.id) {
      fetchComplaintData();
    }
  }, [managerId?.id]);

  // useEffect(() => {
  //   if (id !== "new") {
  //     fetchSingleData();
  //   }

  //   getTeamsDetailsbyuserid(id);
  //   fetchOfficeUser();
  //   // fetchAreaManager();
  // }, [managerId]);

  // useEffect(() => {
  //   fetchAreaManager();
  // }, [teamsDetails]);

  // const fetchAreaManager = async () => {
  //   const res = await getAllAreaManager();
  //   if (res.status) {
  //     console.log(`teamsDetails`, teamsDetails);
  //     const managers = res.data.filter(
  //       (manager) => manager.id == teamsDetails?.manager,
  //     );
  //     console.log(`managers`, managers);
  //     setAllManager(managers);
  //   } else {
  //     setAllManager([]);
  //   }
  // };

  const fetchComplaintData = async () => {
    // The manager-wise list needs a manager id in the URL. On first mount
    // managerId is not known yet (fetchSingleData sets it later), and calling
    // with an empty id produced .../get-area-manager-to-complaints/?... → 404,
    // leaving the dropdown empty so the row's complaint never showed as
    // prefilled. Wait for a real id; the effect below re-runs once it exists.
    if (managerId?.type !== "office" && !managerId?.id) {
      setComplaintData([]);
      return;
    }
    // include_pending_punch: a complaint resolved while its stock punch was
    // still awaiting approval must stay selectable here, or the punch can
    // never be approved.
    const res = managerId.type === "office"
      ? await getAllComplaintIdList(true)
      : await getAllComplaintIdListMangerWise(managerId.id, "", true);
    if (res.status) {
      setComplaintData(res.data);
    } else {
      setComplaintData([]);
    }
  };
  // Ask for the one user this screen is about, rather than sifting the whole
  // company list — that list hides soft-deleted users and users another admin
  // created, either of which emptied this field. Same change as the punch
  // screens; the list stays as the fallback.
  const fetchOfficeUser = async () => {
    const res = await getSingleUserById(id);
    if (res?.status && res?.data?.id) {
      setAllofficeUser([res.data]);
      return;
    }
    const list = await getAllOfficeUser();
    setAllofficeUser(
      list?.status ? list.data.filter((officeUser) => officeUser?.id == id) : [],
    );
  };

  const itemFormatOptionLabel = ({ label, unique_id, image }) => (
    <div className="d-flex">
      <img
        src={`${process.env.REACT_APP_API_URL}${image}`}
        className="avatar me-2"
      />
      <span className="small d-grid">
        <span>{label}</span>
        <span className="text-gray">{unique_id}</span>
      </span>
    </div>
  );
  const today = new Date().toISOString().split("T")[0];

  console.log("teamsDetails =", teamsDetails);
  console.log("freeSupervisorData =", freeSupervisorData);
  console.log("freeUserData =", freeUserData);

  return (
    <>
      <Helmet>
        <title>
          {type === "view" ? "View" : "Approve"} Stock Punch · CMS Electricals
        </title>
      </Helmet>

      <Col md={12} data-aos={"fade-up"} data-aos-delay={200}>
        <CardComponent
          showCardHeader={true}
          className={type === "view" && "after-bg-light"}
          title={`${type === "view" ? "View" : "Approve"} Stock  Punch`}
        >
          <Formik
            enableReinitialize={true}
            initialValues={{
              // expense_punch_for:
              //   (edit.length > 0 && edit?.[0]?.expense_punch_for) || 1,
              expense_punch_for:
                (edit.length > 0 && edit?.[0]?.expense_punch_for) || 1,

              // ✅ Punch date prefill
              punch_date: today,

              items: allItems || [
                {
                  item_name: "",
                  prev_qty: "",
                  prev_amount: "",
                  qty: "",
                  amount: "",
                  sub_total: "",
                },
              ],
              complaint_id: edit?.[0]?.complaintsDetails.complaint_id || "",
              // complaint_id: edit?.[0]?.complaint_id || "",
              // regional_office:
              //   edit?.[0]?.companyDetails?.selectedRegionalOffices[0]?.id || "",
              // sales_area_id:
              //   edit?.[0]?.companyDetails?.selectedSalesAreas[0]?.id || "",
              //             regional_office: edit?.[0]
              // ? {
              //     label:
              //       edit[0]?.complaintsDetails?.companyDetails
              //         ?.selectedRegionalOffices?.[0]?.regional_office_name,
              //     value:
              //       edit[0]?.complaintsDetails?.companyDetails
              //         ?.selectedRegionalOffices?.[0]?.id,
              //   }
              // : null,

              // sales_area_id: edit?.[0]
              //   ? {
              //       label:
              //         edit[0]?.complaintsDetails?.companyDetails
              //           ?.selectedSaleAreas?.[0]?.sales_area_name,
              //       value:
              //         edit[0]?.complaintsDetails?.companyDetails
              //           ?.selectedSaleAreas?.[0]?.id,
              //     }
              //   : null,

              // complaint_id: edit?.[0]?.complaint_id || "",

              regional_office: edit?.[0]
                ? {
                    label:
                      edit?.[0]?.complaintsDetails?.companyDetails
                        ?.selectedRegionalOffices?.[0]?.regional_office_name,
                    value:
                      edit?.[0]?.complaintsDetails?.companyDetails
                        ?.selectedRegionalOffices?.[0]?.id,
                  }
                : null,

              sales_area_id: edit?.[0]
                ? {
                    label:
                      edit?.[0]?.complaintsDetails?.companyDetails
                        ?.selectedSaleAreas?.[0]?.sales_area_name,
                    value:
                      edit?.[0]?.complaintsDetails?.companyDetails
                        ?.selectedSaleAreas?.[0]?.id,
                  }
                : null,

              office_users_id: edit?.[0]?.user_id || "",
              // ✅ AUTO PREFILL — VERY IMPORTANT

              area_manager_id: teamsDetails?.manager
                ? {
                    label:
                      allManager?.find((m) => m.id === teamsDetails.manager)
                        ?.name || "",
                    value: teamsDetails.manager,
                  }
                : null,

              supervisor_id: teamsDetails?.supervisor
                ? {
                    label:
                      freeSupervisorData?.find(
                        (s) => s.id === teamsDetails.supervisor,
                      )?.name || "",
                    value: teamsDetails.supervisor,
                  }
                : null,

              end_users_id: teamsDetails?.team_member
                ? {
                    label:
                      freeUserData?.find(
                        (u) => u.id === teamsDetails.team_member,
                      )?.name || "",
                    value: teamsDetails.team_member,
                  }
                : null,

                punch_date : edit?.[0]?.punch_at ? edit[0].punch_at.split(" ")[0] : today,

              payment_images: [
                { image: "", title: "", transaction_id: "", payment_mode: "" },
              ],
            }}
            // validationSchema={addStockPunchSchema}
            onSubmit={handleSubmit}
          >
            {(props) => {
              return (
                <Form onSubmit={props?.handleSubmit}>
                  <div className="mb-7 d-flex gap-2">
                    {/* <Form.Group as={Col} md={3}>
                      <Form.Label className="small">{t("Office")} </Form.Label>
                      <Select
                        placeholder="Office"
                        menuPortalTarget={document.body}
  isClearable
  name="office_users_id"
  options={allOfficeUser?.map(user => ({
    label: user.name,
    value: user.id,
  }))}

  value={
    allOfficeUser
      ?.map(user => ({ label: user.name, value: user.id }))
      .find(opt => opt.value === props.values.office_users_id) || null
  }
                        isDisabled={
                          edit?.id ||
                          props?.values?.area_manager_id ||
                          props?.values?.supervisor_id ||
                          props?.values?.end_users_id
                        }
                        onChange={(e) => {
                          if (e == null) {
                            props.resetForm();
                            setComplaintDetails({});
                            return;
                          }

                          setManagerId({
                            type: "office",
                            id: e?.value,
                          });
                          props.setFieldValue("office_users_id", e.value);
                          props.setFieldValue("area_manager_id", "");
                          // props.setFieldValue(super, "");
                          props.setFieldValue("endUserName", "");

                          setComplaintDetails({});

                          // setRequestForName(e?.label);
                          // fetchUserWalletBalance(e?.value, "office_user");
                        }}
                      />
                    </Form.Group> */}
                    {/* <Form.Group as={Col} md={3}>
  <Form.Label className="small">{t("Office")}</Form.Label>

  <Select
    placeholder="Office"
    menuPortalTarget={document.body}
    name="office_users_id"
    isClearable={false}

    options={
      edit?.length > 0
        ? [
            {
              label: edit[0].user_name,
              value: edit[0].user_id,
            },
          ]
        : []
    }

    value={
      edit?.length > 0
        ? {
            label: edit[0].user_name,
            value: edit[0].user_id,
          }
        : null
    }

    onChange={(e) => {
  props.setFieldValue("office_users_id", e?.value || "");

  if (e) {
    // 🔥 office select hote hi baaki disable ho jayenge
    props.setFieldValue("area_manager_id", null);
    props.setFieldValue("supervisor_id", null);
    props.setFieldValue("end_users_id", null);
  }
}}
  />
</Form.Group> */}

                    <Form.Group as={Col} md={3}>
                      <Form.Label className="small">{t("Office")}</Form.Label>

                      <Select
                        placeholder="Office"
                        menuPortalTarget={document.body}
                        name="office_users_id"
                        isClearable // ✅ X cross icon
                        isDisabled={managerSelectedByUser}
                        options={
                          edit?.length > 0
                            ? [
                                {
                                  label: edit[0].user_name,
                                  value: edit[0].user_id,
                                },
                              ]
                            : []
                        }
                        value={
                          props.values.office_users_id
                            ? {
                                label: edit?.[0]?.user_name,
                                value: edit?.[0]?.user_id,
                              }
                            : null
                        }
                        onChange={(e) => {
                          // value set
                          props.setFieldValue(
                            "office_users_id",
                            e?.value || "",
                          );

                          if (e) {
                            // ✅ user ne select kiya → disable others
                            setOfficeSelectedByUser(true);
                            setManagerId({ type: "office", id: e.value });

                            props.setFieldValue("area_manager_id", null);
                            props.setFieldValue("supervisor_id", null);
                            props.setFieldValue("end_users_id", null);
                          } else {
                            // ✅ X se clear → enable others
                            setOfficeSelectedByUser(false);
                            setManagerId({ type: "", id: "" });
                          }
                        }}
                      />
                    </Form.Group>
                    {/* <Expense_punch_others
                                  props={props}
                                  id={id}
                                  managerName={`area_manager_id`}
                                  supervisorName={`supervisor_id`}
                                  endUserName={`end_users_id`}
                                  setManagerId={setManagerId}
                                  edit={edit}
                                /> */}
                    <Form.Group as={Col} md={3}>
                      <Form.Label className="small">{t("Manager")}</Form.Label>
                      <Select
                        placeholder={t("Manager")}
                        menuPortalTarget={document.body}
                        // value={main?.area_manager_id}=
                        name="area_manager_id"
                        // value={props?.values?.area_manager_id}
                        //                         value={
                        //   allManager.length > 0
                        //     ? { label: allManager[0].name, value: allManager[0].id }
                        //     : null
                        // }
                        // value={props?.values?.area_manager_id || null}
                        value={props.values.area_manager_id || null}
                        isClearable={true}
                        options={allManager?.map((user) => ({
                          label: user.name,
                          value: user.id,
                        }))}
                        // isDisabled={edit?.id || props?.values?.office_users_id}
                        isDisabled={officeSelectedByUser}
                        onChange={(e) => {
                          // 🔥 if CLEAR button clicked (e = null)
                          if (!e || e == null) {
                            props.resetForm();
                            setComplaintDetails({});

                            props.setFieldValue("area_manager_id", null);
                            props.setFieldValue("supervisor_id", null);
                            props.setFieldValue("end_users_id", null);
                            // setManagerId(null);
                            setManagerId({ type: "", id: "" });
                            setManagerSelectedByUser(false);
                            setFreeUserData([]);
                            return; // stop further code
                          }
                          setManagerSelectedByUser(true);
                          // 🔥 if normal selection
                          handleManagerChange(e?.value);

                          //  fetchFreeSupervisorData(e?.value);

                          props.setFieldValue("area_manager_id", e);

                          // props.setFieldValue(
                          //   "supervisor_id",
                          //   supervisorId.m
                          // );
                          props.setFieldValue("end_users_id", null);

                          setManagerId({
                            type: "manager",
                            id: e?.value,
                          });

                          setFreeUserData([]);
                        }}
                      />
                    </Form.Group>
                    <Form.Group as={Col} md={3}>
                      <Form.Label className="small">
                        {t("Supervisor")}
                      </Form.Label>
                      <Select
                        placeholder={t("Supervisor")}
                        name={"supervisor_id"}
                        menuPortalTarget={document.body}
                        // value={main?.supervisor_id}
                        // value={props?.values?.supervisor_id}
                        //                         value={
                        //   freeSupervisorData
                        //     ?.map(s => ({ label: s.name, value: s.id }))
                        //     .find(opt => opt.value === props.values.supervisor_id?.value) || null
                        // }
                        value={props.values.supervisor_id || null}
                        isClearable={true}
                        options={freeSupervisorData?.map((user) => ({
                          label: user.name,
                          value: user.id,
                        }))}
                        // isDisabled={edit?.id || props?.values?.office_users_id}
                        isDisabled={officeSelectedByUser}
                        // name={}
                        onChange={(e) => {
                          if (!e || e == null) {
                            props.setFieldValue("supervisor_id", null);
                            props.setFieldValue("end_users_id", null);
                            setFreeUserData([]);
                            setManagerId(null);
                            return;
                          }
                          setManagerSelectedByUser(true);
                          handleSupervisorChange(e?.value, props.setFieldValue);

                          props.setFieldValue("supervisor_id", e);
                          setManagerId({
                            type: "manager",
                            id: e?.value,
                          });
                          // setRequestForName(e?.label);
                          // fetchUserWalletBalance(e?.value, "supervisor_user");
                        }}
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={3}>
                      <Form.Label className="small">{t("End User")}</Form.Label>
                      <Select
                        placeholder={t("End User")}
                        name={"end_users_id"}
                        menuPortalTarget={document.body}
                        // value={main?.end_users_id}
                        value={props.values.end_users_id || null}
                        isClearable={true}
                        options={freeUserData?.map((user) => ({
                          label: user.name,
                          value: user.id,
                        }))}
                        // isDisabled={edit?.id || props?.values?.office_users_id}
                        isDisabled={officeSelectedByUser}
                        // name={endUserName}
                        onChange={(e) => {
                          props.setFieldValue("end_users_id", e);
                          // setRequestForName(e?.label);
                          setManagerId({
                            type: "manager",
                            id: e?.value,
                          });
                        }}
                      />
                    </Form.Group>
                  </div>
                  <Row className="g-3 ">
                    <Form.Group as={Col} md={3}>
                      <Form.Label>
                        {t("Select Complaint")}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        menuPortalTarget={document.body}
                        name={`complaint_id`}
                        // value={props.values.complaint_id}
                        // The two APIs name the id differently: manager-wise
                        // returns complaints.* (id), the office list returns
                        // complaint_id. Options and the selected-value finder
                        // must use the SAME key or the picked complaint never
                        // shows as selected.
                        value={
                          complaintData
                            ?.map((itm) => ({
                              label: itm.complaint_unique_id,
                              value: itm.complaint_id ?? itm.id,
                            }))
                            .find(
                              (opt) =>
                                String(opt.value) ===
                                String(props.values.complaint_id),
                            ) || null
                        }
                        options={complaintData?.map((itm) => ({
                          label: itm.complaint_unique_id,
                          ...itm,
                          value: itm.complaint_id ?? itm.id,
                        }))}
                        //                         onChange={(e) => {
                        //                           // Set complaint_id always
                        //                           // props.setFieldValue("complaint_id", e);
                        //                           props.setFieldValue("complaint_id", e.value);
                        //                           const saId = !e?.regionalOffice
                        //                             ? JSON.parse(e.sale_area_id)[0]
                        //                             : e?.saleAreaDetails?.[0]?.id;
                        //                           setSelectedSAId(saId);

                        //                           fetchSaData(
                        //                             !e?.regionalOffice
                        //                               ? JSON.parse(e.ro_id)[0]
                        //                               : e?.regionalOffice?.[0]?.id,
                        //                           );

                        //                           // CLEAR CASE
                        //                           if (!e) {
                        //                             props.setFieldValue("regional_office", "");
                        //                             props.setFieldValue("sales_area_id", "");
                        //                             setComplaintDetails({});
                        //                             return;
                        //                           }

                        //                           let selectedRO = null;
                        //                           let selectedSA = null;

                        // //                           if (!e?.regionalOffice) {
                        // //                             const roId = e?.ro_id
                        // //                               ? JSON.parse(e.ro_id)[0]
                        // //                               : null;
                        // //                             const saId = JSON.parse(e.sale_area_id)[0];

                        // //                             // selectedRO = allRegionalOffice.find(
                        // //                             //   (ro) => ro.ro_id == roId,
                        // //                             // );

                        // //                             selectedRO = allRegionalOffice.find(
                        // //   (ro) => ro.value === roId,
                        // // );

                        // //                             console.log("allsa", allSa);

                        // //                             // fetchSaData(selectedRO?.ro_id);
                        // //                           }
                        //                             if (!e?.regionalOffice) {
                        //   const roId = e?.ro_id
                        //     ? JSON.parse(e.ro_id)[0]
                        //     : null;

                        //   selectedRO = allRegionalOffice.find(
                        //     (ro) => ro.value === roId
                        //   );

                        //   console.log("allsa", allSa);
                        // }
                        //                            else {
                        //                             // selectedRO = allRegionalOffice.find(
                        //                             //   (ro) => ro.ro_id == e?.regionalOffice?.[0]?.id,
                        //                             // );
                        //                             const roId = e?.regionalOffice?.[0]?.id;
                        //                             selectedRO = allRegionalOffice.find(
                        //   (ro) => ro.value === roId,
                        // );
                        //                             // fetchSaData(selectedRO?.ro_id);

                        //                             console.log("allsa", allSa);
                        //                           }

                        //                           /* -------------------------------
                        //                                        SALES AREA FIND LOGIC
                        //                                 --------------------------------*/

                        //                           // CASE 1: sale area id is a JSON string "[12]"

                        //                           // Fetch Sales Area data

                        //                           /* -------------------------------
                        //                                         SET FORM VALUES
                        //                                 --------------------------------*/

                        //                           // props.setFieldValue("regional_office", {
                        //                           //   label: selectedRO?.regional_office_name,
                        //                           //   value: selectedRO?.ro_id,
                        //                           // });

                        //                              props.setFieldValue("regional_office", selectedRO || null);

                        //                           setComplaintDetails((prev) => ({
                        //                             ...prev,
                        //                             ...e,
                        //                           }));

                        //                           console.log("complaint details", complaintDetails);
                        //                         }}
                        onChange={async (e) => {
                          console.log("COMPLAINT RAW =", e);
                          console.log(
                            "FINAL complaintDetails =",
                            complaintDetails,
                          );
                          if (!e) {
                            props.setFieldValue("complaint_id", "");
                            props.setFieldValue("regional_office", null);
                            props.setFieldValue("sales_area_id", null);
                            setComplaintDetails({});
                            return;
                          }

                          // complaint id
                          props.setFieldValue("complaint_id", e.value);
                          // ⭐ VERY IMPORTANT — old SA clear
                          props.setFieldValue("sales_area_id", null);

                          // ---------- RO ----------
                          // Defensive: office-list rows carry no ro_id JSON —
                          // JSON.parse(undefined) here used to throw and kill
                          // the rest of the prefill.
                          const roId = (() => {
                            try {
                              return !e?.regionalOffice
                                ? e?.ro_id
                                  ? JSON.parse(e.ro_id)[0]
                                  : null
                                : e?.regionalOffice?.[0]?.id;
                            } catch (_) {
                              return null;
                            }
                          })();

                          const selectedRO = allRegionalOffice.find(
                            (ro) => ro.value === roId,
                          );

                          props.setFieldValue("regional_office", selectedRO);

                          // load SA list
                          // fetchSaData(roId);

                          // // ---------- SA ----------
                          // const saId = !e?.saleAreaDetails
                          //   ? JSON.parse(e.sale_area_id)[0]
                          //   : e?.saleAreaDetails?.[0]?.id;

                          // const selectedSA = allSa.find(
                          //   (sa) => sa.value == saId
                          // );

                          // props.setFieldValue("sales_area_id", selectedSA);

                          // load SA list
                          const saOptions = await fetchSaData(roId);

                          // ---------- SA ----------
                          const saId = (() => {
                            try {
                              return !e?.saleAreaDetails
                                ? e?.sale_area_id
                                  ? JSON.parse(e.sale_area_id)[0]
                                  : null
                                : e?.saleAreaDetails?.[0]?.id;
                            } catch (_) {
                              return null;
                            }
                          })();

                          const selectedSA = saOptions.find(
                            (sa) => sa.value === saId,
                          );

                          props.setFieldValue(
                            "sales_area_id",
                            selectedSA || null,
                          );

                          // outlet + details card
                          // ✅ FINAL — left card always update
                          // ✅ ULTRA SAFE NORMALIZER
                          const roIdParsed = e?.ro_id
                            ? JSON.parse(e.ro_id)[0]
                            : null;
                          const saIdParsed = e?.sale_area_id
                            ? JSON.parse(e.sale_area_id)[0]
                            : null;

                          setComplaintDetails({
                            companyDetails: {
                              selectedRegionalOffices: [
                                {
                                  id: roIdParsed,
                                  regional_office_name: e?.ro_name || "",
                                },
                              ],

                              selectedSaleAreas: [
                                {
                                  id: saIdParsed,
                                  sales_area_name: e?.sa_name || "",
                                },
                              ],

                              outletDetail: {
                                outlet_unique_id: e?.outlet_unique_id || "",
                                outlet_name: e?.outlet_name || "",
                                customer_code: e?.outlet_customer_code || "",
                                outlet_category: e?.outlet_category || "",
                              },
                            },

                            complaint_punched_amount:
                              e?.complaint_punched_amount ||
                              e?.stock_punch_transfer ||
                              0,
                          });
                        }}
                      />
                      <ErrorMessage
                        name="complaint_id"
                        component="small"
                        className="text-danger"
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={3}>
                      <Form.Label className="small">
                        {t("Regional Office Name")}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        menuPortalTarget={document.body}
                        name={`regional_office`}
                        value={props?.values?.regional_office}
                        options={allRegionalOffice}
                        // options={allRegionalOffice?.map((itm) => ({
                        //   label: itm?.regional_office_name,
                        //   value: itm?.ro_id,
                        // }))}
                        isClearable
                        isDisabled={props?.values?.complaint_id}
                        onChange={(e) => {
                          setManagerId({
                            type: "manager",
                            id: e?.value,
                          });
                          props.setFieldValue(`complaint_id`, "");
                          props.setFieldValue(`regional_office`, e);
                        }}
                      />
                      <ErrorMessage
                        name="regional_office"
                        component="small"
                        className="text-danger"
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={3}>
                      <Form.Label className="small">
                        {t("Sales Area")} <span className="text-danger">*</span>
                      </Form.Label>
                      <Select
                        menuPortalTarget={document.body}
                        value={props?.values?.sales_area_id}
                        name={`sales_area_id`}
                        options={allSa}
                        // options={allSa?.map((itm) => ({
                        //   label: itm?.sales_area_name,
                        //   value: itm?.id,
                        // }))}
                        // isDisabled={props?.values?.complaint_id}
                        isDisabled={props?.values?.complaint_id}
                        isClearable
                        onChange={(e) => {
                          // fetchComplaintData("4", e?.value);
                          setManagerId({
                            type: "manager",
                            id: e?.value,
                          });
                          props.setFieldValue(`complaint_id`, "");
                          props.setFieldValue(`complaint_id`, "");
                          props.setFieldValue(`area_manager_id`, e);
                        }}
                      />
                      <ErrorMessage
                        name="sales_area_id"
                        component="small"
                        className="text-danger"
                      />
                    </Form.Group>

                    <Form.Group as={Col} md={3}>
                      <Form.Label className="small">
                        {t("Select Punch Date")}
                      </Form.Label>
                      <DatePickercomp
                        name="punch_date"
                        value={props?.values?.punch_date}
                        label={t("Select Punch Date")}
                        disabled={true}
                        sendDate={(value) => {
                          props.setFieldValue("punch_date", value);
                        }}
                      />
                    </Form.Group>
                  </Row>
                  <div className="row" style={{ marginTop: "20px" }}>
                    <Col md={6}>
                      <div className="p-20 shadow rounded h-100">
                        <strong className="text-secondary">
                          {t("Outlet Details")}
                        </strong>

                        <div className="mt-2">
                          <table className="table-sm table">
                            <tbody>
                              <tr>
                                <th>{t("Regional Office ")} :</th>
                                {/* <td>
                                  {edit?.[0]?.companyDetails?.selectedRegionalOffices[0]?.regional_office_name ||
                                    "-"}
                                </td> */}
                                <td>
                                  {complaintDetails?.companyDetails
                                    ?.selectedRegionalOffices?.[0]
                                    ?.regional_office_name ||
                                    edit?.[0]?.complaintsDetails?.companyDetails
                                      ?.selectedRegionalOffices?.[0]
                                      ?.regional_office_name ||
                                    "-"}
                                </td>
                              </tr>

                              <tr>
                                <th>{t("Sales Area")} :</th>
                                {/* <td> */}
                                {/* {edit?.[0]?.companyDetails?.selectedSalesAreas[0]?.sales_area_name || "-"} */}

                                {/* {accountBalance?.account_holder_name || "-"} */}
                                {/* </td> */}
                                <td>
                                  {complaintDetails?.companyDetails
                                    ?.selectedSaleAreas?.[0]?.sales_area_name ||
                                    edit?.[0]?.complaintsDetails?.companyDetails
                                      ?.selectedSaleAreas?.[0]
                                      ?.sales_area_name ||
                                    "-"}
                                </td>
                              </tr>
                              <tr>
                                <th>{t("Outlet Unique ID")} :</th>
                                {/* <td> */}
                                {/* {complaintDetails?.outlet?.[0] */}
                                {/* // ?.outlet_unique_id || */}
                                {/* // complaintDetails.outlet_unique_id || */}
                                {/* "-"} */}
                                {/* {props.values?.account_id?.label || "-"} */}
                                {/* </td> */}
                                <td>
                                  {complaintDetails?.companyDetails
                                    ?.outletDetail?.outlet_unique_id ||
                                    edit?.[0]?.complaintsDetails?.companyDetails
                                      ?.outletDetail?.outlet_unique_id ||
                                    "-"}
                                </td>
                              </tr>

                              <tr>
                                <th>{t("Outlet Name")} :</th>
                                {/* <td>₹ {accountBalance?.balance || "0.00"}</td> */}

                                {/* <td>
                                  {complaintDetails?.outlet?.[0]?.outlet_name ||
                                    complaintDetails.outlet_name ||
                                    "-"}
                                </td> */}
                                <td>
                                  {complaintDetails?.companyDetails
                                    ?.outletDetail?.outlet_name ||
                                    edit?.[0]?.complaintsDetails?.companyDetails
                                      ?.outletDetail?.outlet_name ||
                                    "-"}
                                </td>
                              </tr>
                              <tr>
                                <th>{t("Customer Code")} :</th>
                                {/* <td>
                                                                                                                                      {allAccountByBankId?.find(
                                                                                                                                        (item) =>
                                                                                                                                          item?.value ===
                                                                                                                                          props.values?.account_id?.value
                                                                                                                                      )?.branch || "-"}
                                                                                                                                    </td> */}
                                {/* <td>
                                  {complaintDetails?.outlet?.[0]
                                    ?.customer_code ||
                                    complaintDetails.outlet_customer_code ||
                                    "-"}
                                </td> */}
                                <td>
                                  {complaintDetails?.companyDetails
                                    ?.outletDetail?.customer_code ||
                                    edit?.[0]?.complaintsDetails?.companyDetails
                                      ?.outletDetail?.customer_code ||
                                    "-"}
                                </td>
                              </tr>
                              <tr>
                                <th>{t("Catergory")} :</th>
                                {/* <td>
                                                                                                                                      {allAccountByBankId?.find(
                                                                                                                                        (item) =>
                                                                                                                                          item?.value ===
                                                                                                                                          props.values?.account_id?.value
                                                                                                                                      )?.branch || "-"}
                                                                                                     </td> */}
                                {/* <td>
                                  {complaintDetails?.outlet?.[0]
                                    ?.outlet_category ||
                                    complaintDetails.outlet_category ||
                                    "-"}
                                </td> */}
                                <td>
                                  {complaintDetails?.companyDetails
                                    ?.outletDetail?.outlet_category ||
                                    edit?.[0]?.complaintsDetails?.companyDetails
                                      ?.outletDetail?.outlet_category ||
                                    "-"}
                                </td>
                              </tr>
                              <tr>
                                <th>{t("Already Punched Balance ")} :</th>
                                <td>
                                  {/* ₹{complaintDetails?.amount_punched || "0.00"} */}
                                  {formatAmountINR(
                                    complaintDetails?.complaint_punched_amount ||
                                      edit?.[0]?.stock_punch_transfer ||
                                      0
                                  )}
                                </td>
                                {/* {complaintData[0]?.fund_amount  || "0.00"} */}
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="p-20 shadow rounded h-100">
                        <strong className="text-secondary">
                          {t("User Details")}
                        </strong>

                        <div className="mt-2">
                          <table className="table-sm table">
                            <tbody>
                              <tr>
                                <th>{t("User Name")} :</th>
                                {/* <td>{userDetails?.request_by_name || "-"}</td> */}
                                <td>{edit?.[0]?.user_name || "-"}</td>
                              </tr>

                              <tr>
                                <th>{t("Transferred Amount")} :</th>
                                <td>
                                  {formatAmountINR(
                                    userDetails?.transfer_amount ??
                                      edit?.[0]?.stock_punch_transfer ??
                                      0,
                                  )}
                                </td>
                              </tr>

                              {/* <tr>
                                                                                                            <th>{t("Closing Balance")} :</th>
                                                                                                            <td>
                                                                                                                                      ₹
                                                                                                                                      {userDetails[0].closing_balance || "0.00"}
                                                                                                                                    </td>
                                                                                                          </tr> */}
                              <tr>
                                <th>{t("Punched Amount")} :</th>
                                <td>
                                  {formatAmountINR(
                                    userDetails?.expense_transfer_amount ??
                                      edit?.[0]?.stock_punch_transfer ??
                                      0,
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <th>{t("Remaining Balance")} :</th>
                                <td>
                                  {formatAmountINR(
                                    userDetails?.remaining_amount ?? 0,
                                  )}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </div>

                  <Row className="g-3">
                    {type === "view" ? (
                      <ViewExpensePunch edit={edit} />
                    ) : (
                      <>
                        <FieldArray name="items">
                          {({ remove, push }) => (
                            <div className="table-scroll p-2 my-3">
                              {/* <div className="my-3">
                                <span>
                                  {" "}
                                  User Name :{" "}
                                  <span className="fw-bold">
                                    {" "}
                                    {edit[0]?.user_name ?? "--"}
                                  </span>
                                </span>
                                <br />
                                <span>
                                  {" "}
                                  Complain No. :{" "}
                                  <span className="fw-bold">
                                    {" "}
                                    {edit[0]?.complaint_unique_id ?? "--"}
                                  </span>
                                </span>
                              </div> */}

                              {props.values.expense_punch_for == 2 && (
                                <div className=" mb-4 ">
                                  Manager Name:{" "}
                                  <span className="fw-bold">
                                    {props.values?.area_manager_id?.name ??
                                      "--"}
                                  </span>
                                  <br />
                                  {props.values?.supervisor_id?.name && (
                                    <span>
                                      {" "}
                                      Supervisor Name:{" "}
                                      <span className="fw-bold">
                                        {" "}
                                        {props.values?.supervisor_id?.name ??
                                          "--"}
                                      </span>
                                    </span>
                                  )}
                                  <br />
                                  {props.values?.end_users_id?.name && (
                                    <span>
                                      Enduser Name:{" "}
                                      <span className="fw-bold">
                                        {" "}
                                        {props.values?.end_users_id?.name ??
                                          "--"}
                                      </span>
                                    </span>
                                  )}
                                </div>
                              )}

                              {props.values.items.length > 0 && (
                                <Table
                                  striped
                                  hover
                                  className="text-body bg-new Roles"
                                >
                                  <thead>
                                    <tr>
                                      <th>Item Name</th>
                                      <th>Punch Quantity</th>
                                      <th>Punch Amount</th>
                                      <th>Approve Quantity</th>
                                      <th>Approve Amount</th>
                                      {/* <th>Remaining Quantity </th>
                                      <th>Remaining Amount</th> */}
                                      <th>Total Price </th>
                                      {/* <th>payment Mode</th>
                                      <th>Transaction Id </th> */}
                                      <th>Punch Date & Time</th>
                                      <th style={{ minWidth: "220px" }}>Remarks</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {props.values.items.map((itm, index) => (
                                      <tr key={index}>
                                        <td width={160}>
                                          <Select
                                            className="text-start"
                                            menuPortalTarget={document.body}
                                            name={`items.${index}.item_name`}
                                            value={{
                                              label: itm?.item_name,
                                              image: itm?.item_images,
                                            }}
                                            isDisabled
                                            formatOptionLabel={
                                              itemFormatOptionLabel
                                            }
                                          />
                                          <ErrorMessage
                                            name={`items.${index}.item_name`}
                                            component="span"
                                            className="text-danger"
                                          />
                                        </td>
                                        {/* <td>
                                          <Form.Control
                                            name={`items.${index}.qty`}
                                            placeholder="0"
                                            value={twoDecimal(itm?.remaining_approved_qty)}
                                            disabled
                                            onChange={props.handleChange}
                                          />
                                        </td> */}
                                        <td>
                                          <Form.Control
                                            value={twoDecimal(itm?.punch_qty)}
                                            disabled
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            value={twoDecimal(itm?.punch_amount)}
                                            disabled
                                          />
                                        </td>

                                        {/* <td>
                                          <Form.Control
                                            name={`items.${index}.approved_qty`}
                                            value={twoDecimal(itm.approved_qty)}
                                            onChange={(e) => {
                                              // const maxValue =
                                              //   itm.remaining_approved_qty;
                                              const maxValue = itm.remaining_qty;

                                              if (
                                                +e.target.value <= +maxValue
                                              ) {
                                                props.handleChange(e);

                                                props.setFieldValue(
                                                  `items.${index}.total_price`,
                                                  +e.target.value *
                                                    +itm?.item_price,
                                                );

                                                props.setFieldValue(
                                                  `items.${index}.remaining_qty`,

                                                  +itm.remaining_approved_qty 
                                                  +itm.remaining_qty -

                                                    +e.target.value,
                                                );
                                              } else {
                                                e.target.value = +maxValue;
                                                props.handleChange(e);

                                                props.setFieldValue(
                                                  `items.${index}.total_price`,
                                                  +e.target.value *
                                                    +itm?.item_price,
                                                );

                                                props.setFieldValue(
                                                  `items.${index}.remaining_qty`,
                                                  0,
                                                );
                                              }
                                            }}
                                          />
                                          <ErrorMessage
                                            name={`items.${index}.approved_qty`}
                                            component="span"
                                            className="text-danger"
                                          />
                                        </td> */}
                                        <td>
                                          <Form.Control
                                            type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                                            name={`items.${index}.approved_qty`}
                                            value={
                                              props.values.items[index]
                                                .approved_qty
                                            }
                                            onChange={(e) => {
                                              const rawValue = e.target.value;
                                              const currentItem =
                                                props.values.items[index];
                                              const maxQty = Number(

                                                  currentItem.punch_qty ||
                                                  0,
                                              );
                                              const price = Number(
                                                itm.item_price || 0,
                                              );
                                              const breakdown = itm?.rate_breakdown || [];

                                              // FIFO helper
                                              const calcFifo = (qty) => {
                                                if (breakdown.length === 0) return qty * price;
                                                let total = 0, rem = qty;
                                                for (const row of breakdown) {
                                                  if (rem <= 0) break;
                                                  const take = Math.min(row.qty, rem);
                                                  total += take * row.rate;
                                                  rem -= take;
                                                }
                                                return total;
                                              };

                                              if (rawValue === "") {
                                                // Exact FIFO total, no rounding —
                                                // backend should receive full precision.
                                                const totalPunchAmt = calcFifo(maxQty);
                                                props.setFieldValue(
                                                  `items.${index}.approved_qty`,
                                                  "",
                                                );
                                                props.setFieldValue(
                                                  `items.${index}.approve_amount`,
                                                  0,
                                                );
                                                props.setFieldValue(
                                                  `items.${index}.total_price`,
                                                  0,
                                                );
                                                props.setFieldValue(
                                                  `items.${index}.remaining_qty`,
                                                  maxQty,
                                                );
                                                props.setFieldValue(
                                                  `items.${index}.remaining_amount`,
                                                  totalPunchAmt,
                                                );
                                                return;
                                              }

                                              // Reject anything that isn't a partial decimal number
                                              // so users can't type letters but in-progress decimals
                                              // like "1." are still allowed (the regex permits an
                                              // optional trailing dot).
                                              if (!/^\d*\.?\d{0,3}$/.test(rawValue)) return;

                                              const qty = Number(rawValue);
                                              const exceedsMax = qty > maxQty;
                                              const finalQty = exceedsMax ? maxQty : qty;
                                              // Rounded to 3 decimals at the edge so the
                                              // form/backend store currency-standard
                                              // values instead of leaking JS float noise
                                              // (e.g. 460.95000000000005).
                                              const r3 = (n) => Math.round(Number(n) * 1000) / 1000;
                                              // Money is 2dp: the backend caps and stores amounts in
                                              // paise (approved_amount is a 2dp column), so a 3dp
                                              // amount here only showed "49000.055" next to a punched
                                              // "49000.05" and a total of "49000.06" — three values for
                                              // one line. Quantity stays 3dp.
                                              const r2 = (n) => Math.round(Number(n) * 100) / 100;
                                              const approveAmt = r2(calcFifo(finalQty));
                                              const remainingQty = r3(maxQty - finalQty);
                                              const totalPunchFifo = calcFifo(maxQty);
                                              const remainingAmt = r2(totalPunchFifo - approveAmt);

                                              // Preserve user's raw string so trailing dot
                                              // ("1.") survives re-render and decimal entry
                                              // like "1.5" works. Cap to max number only when
                                              // they exceeded the limit.
                                              props.setFieldValue(
                                                `items.${index}.approved_qty`,
                                                exceedsMax ? r3(finalQty) : rawValue,
                                              );
                                              props.setFieldValue(
                                                `items.${index}.approve_amount`,
                                                approveAmt,
                                              );
                                              props.setFieldValue(
                                                `items.${index}.total_price`,
                                                approveAmt,
                                              );
                                              props.setFieldValue(
                                                `items.${index}.remaining_qty`,
                                                remainingQty,
                                              );
                                              props.setFieldValue(
                                                `items.${index}.remaining_amount`,
                                                remainingAmt,
                                              );
                                            }}
                                          />
                                        </td>

                                        <td>
                                          {/* <Form.Control
                                            value={props.values.items[index].approve_amount}
                                            /> */}
                                          <Form.Control
                                            type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                                            step="0.01"
                                            name={`items.${index}.approve_amount`}
                                            value={
                                              props.values.items[index]
                                                .approve_amount
                                            }
                                            onChange={(e) => {
                                              const rawValue = e.target.value;
                                              const price = Number(
                                                itm.item_price || 0,
                                              );
                                              const currentItem =
                                                props.values.items[index];
                                              const maxQty = Number(
                                                currentItem.original_remaining_qty ||
                                                  currentItem.punch_qty ||
                                                  0,
                                              );
                                              const punchAmount = Number(
                                                currentItem.punch_amount || 0,
                                              );

                                              if (rawValue === "") {
                                                props.setFieldValue(
                                                  `items.${index}.approve_amount`,
                                                  "",
                                                );
                                                props.setFieldValue(
                                                  `items.${index}.approved_qty`,
                                                  0,
                                                );
                                                props.setFieldValue(
                                                  `items.${index}.total_price`,
                                                  0,
                                                );
                                                props.setFieldValue(
                                                  `items.${index}.remaining_qty`,
                                                  maxQty,
                                                );
                                                props.setFieldValue(
                                                  `items.${index}.remaining_amount`,
                                                  punchAmount,
                                                );
                                                return;
                                              }

                                              // Allow only digits with optional dot + up to 3
                                              // decimals so the trailing dot of an in-progress
                                              // entry like "1." survives — needed for decimal entry.
                                              if (!/^\d*\.?\d{0,3}$/.test(rawValue)) return;

                                              let amount = Number(rawValue);
                                              const exceedsMax = amount > punchAmount;
                                              if (exceedsMax) amount = punchAmount;

                                              // Rounded to 3 decimals so derived qty doesn't
                                              // carry JS float trail (e.g. 2.2333333333).
                                              const r3 = (n) => Math.round(Number(n) * 1000) / 1000;
                                              const finalQty = price ? r3(amount / price) : 0;
                                              const remainingQty = r3(maxQty - finalQty);
                                              const remainingAmt = r3(remainingQty * price);

                                              props.setFieldValue(
                                                `items.${index}.approved_qty`,
                                                finalQty,
                                              );
                                              // Preserve user's raw string for the field they're
                                              // typing into; cap to capped number only on overflow.
                                              props.setFieldValue(
                                                `items.${index}.approve_amount`,
                                                exceedsMax ? r3(amount) : rawValue,
                                              );
                                              props.setFieldValue(
                                                `items.${index}.total_price`,
                                                exceedsMax ? r3(amount) : rawValue,
                                              );
                                              props.setFieldValue(
                                                `items.${index}.remaining_qty`,
                                                remainingQty,
                                              );
                                              props.setFieldValue(
                                                `items.${index}.remaining_amount`,
                                                remainingAmt,
                                              );
                                            }}
                                          />
                                        </td>
                                        {/* <td>
                                          <Form.Control
                                            // value={itm?.remaining_qty}
                                            value={
                                              props.values.items[index]
                                                .remaining_qty
                                            }
                                            disabled
                                          />
                                        </td>
                                        <td>
                                          <Form.Control
                                            // value={itm?.remaining_amount}
                                            value={
                                              props.values.items[index]
                                                .remaining_amount
                                            }
                                            disabled
                                          />
                                        </td> */}
                                        <td>
                                          {/* <MyInput
                                            type="text" onKeyPress={onlyDecimalKey} onPaste={handleDecimalPaste} inputMode="decimal"
                                            step="0.01"
                                            name={`items.${index}.total_price`}
                                             plaintext
  readOnly
  value={`₹ ${Number(props.values.items[index].total_price || 0).toFixed(2)}`}
                                            onChange={(e) => {
                                              const amount = Number(e.target.value || 0);

                                              // const price = Number(itm.item_price || 0);
                                              // const maxQty = Number(itm.remaining_approved_qty || 0);
                                              // const punchAmount = Number(itm.total_Amount || 0);
                                               const price = Number(itm.item_price || 0);
                                              //  const maxQty = Number(itm.remaining_qty || 0);
                                              const currentItem = props.values.items[index];


                                              const maxQty = Number(
                                              currentItem.original_remaining_qty ??
                                              itm.original_remaining_qty ??
                                               0
                                              );
                                               const punchAmount = Number(itm.punch_amount || 0);

                                              // amount → qty
                                              let qty = price ? amount / price : 0;
                                              if (qty > maxQty) qty = maxQty;

                                              const finalQty = Number(qty.toFixed(2));
                                              const approveAmt = finalQty * price;

                                              const remainingQty = maxQty - finalQty;
                                              const remainingAmt = punchAmount - approveAmt;

                                              props.setFieldValue(`items.${index}.approved_qty`, finalQty);
                                              props.setFieldValue(`items.${index}.approve_amount`, approveAmt);
                                              props.setFieldValue(`items.${index}.total_price`, approveAmt);
                                              props.setFieldValue(`items.${index}.remaining_qty`, remainingQty);
                                              props.setFieldValue(`items.${index}.remaining_amount`, remainingAmt);
                                            }}
                                          /> */}
                                          <Form.Control
                                            plaintext
                                            readOnly
                                            value={`₹ ${Number(props.values.items[index].total_price || 0).toFixed(2)}`}
                                          />
                                        </td>
                                        {/* <td>
                                          <Form.Control
                                            name={`items.${index}.total_price`}
                                            placeholder="0"
                                            value={itm?.total_price}
                                            onChange={props.handleChange}
                                            
                                          />
                                        </td> */}
                                        <td>{itm.punch_at}</td>
                                        <td>
                                          <PunchItemRemarksCell remarks={punchRemarks} itemName={itm?.item_name} canEdit />
                                        </td>

                                        {/* <td>{itm.supplier_name}</td> */}
                                      </tr>
                                    ))}
                                  </tbody>
                                </Table>
                              )}

                              <div className="mt-2 text-end fs-6 fw-bold">
                                Total Amount{" "}
                                {(
                                  Math.round(
                                    props.values.items.reduce(
                                      (total, item) =>
                                        total + Number(item.total_price || 0),
                                      0,
                                    ) * 100,
                                  ) / 100
                                ).toFixed(2)}
                              </div>
                            </div>
                          )}
                        </FieldArray>
                        <FieldArray name={`payment_images`}>
                          {({
                            push: pushPaymentImage,
                            remove: removePaymentImage,
                          }) => (
                            <PaymentImages
                              props={props}
                              id={id}
                              pushPaymentImage={pushPaymentImage}
                              removePaymentImage={removePaymentImage}
                              fromcreate={true}
                            />
                          )}
                        </FieldArray>
                        <Form.Group as={Col} md={12}>
                          <div className="mt-2 text-center">
                            <button
                              type={`button`}
                              onClick={() => setShowAlert(true)}
                              disabled={props?.isSubmitting}
                              className="shadow border-0 purple-combo cursor-pointer px-4 py-1"
                            >
                              {props?.isSubmitting ? (
                                <>
                                  <Spinner
                                    animation="border"
                                    variant="primary"
                                    size="sm"
                                  />
                                  PLEASE WAIT...
                                </>
                              ) : (
                                <>Submit</>
                              )}
                            </button>
                            {/* {(props.values.items.reduce(
                              (total, item) => total + item?.total_price,
                              0
                            ) || 0) > edit[0]?.users_limt && (
                              <span className="text-danger">
                                * Wallet Balance is Low
                              </span>
                            )} */}
                            <ConfirmAlert
                              size={"sm"}
                              defaultIcon={<BsQuestionLg />}
                              deleteFunction={props.handleSubmit}
                              hide={setShowAlert}
                              show={showAlert}
                              title={"Confirm Punch"}
                              description={
                                "Are you sure you want to punch this!!"
                              }
                              // Disable Confirm (and Cancel) while the approval
                              // is in flight — the shared dialog reads
                              // formikProps.isSubmitting.
                              formikProps={props}
                            />
                          </div>
                        </Form.Group>
                      </>
                    )}
                  </Row>
                </Form>
              );
            }}
          </Formik>
        </CardComponent>
      </Col>
    </>
  );
};

export default ApproveStockPunch;
